<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 px-2 py-6">

        <!-- MAIL ROW 1 : META -->
        <div class="flex w-full">
            <div class="vx-row" style="margin:10px; padding:2px;">
              <vs-chip v-if="!noticeBoard.answer" color="#d5d5d5" style="width:100%; height:20px; margin-right:10px;">대기</vs-chip>
              <vs-chip v-if="noticeBoard.answer" color="#28c76f" style="margin-right:10px;">완료</vs-chip>
            </div>
            <div class="flex w-full justify-between items-start ">
                <div class="mail__details">
                    <span>{{ noticeBoard.question }}</span>
                </div>
                <div class="mail-item__meta flex items-center">
                    <span style="width:50px;">{{ noticeBoard.create_time | onlydate }}</span>
                </div>
            </div>
        </div>

        <div class="flex w-full">
            <div class="flex items-center ml-1">
                <!-- <vs-checkbox v-model="isSelectedMail" @click.stop class="vs-checkbox-small ml-0 mr-1"></vs-checkbox> -->
                <!-- <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning fill-current stroke-current': mail.isStarred}, 'w-5', 'h-5']" @click.stop="toggleIsStarred"></feather-icon> -->
            </div>
            <!-- <div class="mail__message truncate ml-3">
                <span>{{ notice.detail | filter_tags }}</span>
            </div> -->
        </div>
        <!-- /MAIL ROW 2 -->
    </div>
</template>

<script>
export default {
  props: ['noticeBoard'],
  selected: [],
  data() {
    return {

    }
  },
}

</script>
